<template>
  <div class="">
    <div class="w-full lg:w-2/5" style="padding:50px 80px">

      <BrokerpadLogo />

      <form v-on:submit.prevent class="bg-white my-6 rounded" autocomplete="on">

        <div class="text-2xl font-light text-gray-700">
          Login to your {{ getAppName }} account
        </div>

        <div class="mt-8">
          <label class="text-base">Email</label>
        </div>

        <div class="mt-2">
          <input type="text"
                 v-model="email"
                 ref='email'
                 class="input-standard"
                 name="email"
                 :disabled="loading"
                 autocomplete='on' />

          <div v-if="errors.email !== null" class="text-red-600 mt-1 text-sm">{{ errors.email }}</div>
        </div>

        <div class="mt-8">
          <label class="text-base">Password</label>
        </div>

        <div class="mt-2">
          <input type="password"
                 v-model="password"
                 @keyup.enter="submit()"
                 class="input-standard"
                 name="password"
                 :disabled="loading"
                 autocomplete='on' />

          <div v-if="errors.password !== null"
            class="text-red-600 mt-1 text-sm">{{ errors.password }}</div>
        </div>

        <div class="mt-10">
          <button
            v-on:click="submit()"
            class="text-white w-full py-4 text-base bg-blue-500 hover:bg-blue-600 font-semibold">
            <template v-if="loading"><img src="/static/img/ajax-loader.gif" class="inline" /></template>
            <template v-else>Login</template>
          </button>
        </div>

        <div class="mt-3 flex items-center">
          <img src="/static/img/icons/icons8-remove_key.png" />
          <router-link to="/auth/forgot-password" class="ml-2 no-underline text-gray-900 hover:underline text-base">
            Forgot your password?
          </router-link>
        </div>
      </form>

      <div class="mt-12">
        <PublicFooter />
      </div>
    </div>

    <div class="hidden lg:block w-3/5"
      style="position:fixed;top:0;right:0;height:100%;">
      <div
        style="width:100%;height:100%;
        background: url(https://images.unsplash.com/photo-1444090542259-0af8fa96557e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2100&q=80) no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;"></div>
    </div>
  </div>
</template>

<script>

  import validator      from "validator"
  import axios          from "axios"
  import PublicFooter   from "@/shared/components/public/Footer"
  import BrokerpadLogo  from '@/shared/components/BrokerpadLogo';

  export default {

    components : {
      BrokerpadLogo,
      PublicFooter
    },

    data() {
      return {
        loading   : false,        
        email     : null,
        password  : null,

        errors : {
          email   : null,
          password: null
        }
      }
    },

    mounted() {
      this.$refs.email.focus()
    },

    methods : {

      submit() {
        this.errors = {
          email   : null,
          password: null
        }

        let email    = this.email
        let password = this.password
        let valid    = true

        if(email == null || !validator.isEmail(email)) {
          this.errors.email = "Please type a valid email."
          valid = false;
        }

        if(password == null || password.length == 0) {
          this.errors.password = "Please type a valid password."
          valid = false;
        }

        if(valid) {
          this.loading = true

          axios.post(process.env.VUE_APP_API_URL + '/api/auth/login', {
            email   : email.toLowerCase().trim(),
            password: password
          }).then(response => {

            localStorage.setItem("bp-broker-jwt", response.data.token)
            this.$store.commit('setIsLoggedIn', true)
            this.$store.commit('setAdminView', 'brokerpad')

            this.getUser({
              force : true
            }, (user) => {

              if(user != null) {
                this.$router.push({
                  name : 'broker-list'
                });
              }
            })
            
          }).catch(e => {
            this.loading      = false
            this.errors.email = "Authentication failed. Please try again."
          })
        }
      },
    },
  }
</script>